import i18next from 'i18next'
import { config } from '@config'
import { DefaultConfig } from '@constants'

/**
 * Method for displaying currency code with price by selected language
 */
const formatCurrencyValueByLocale = (
  currencyCode: string,
  value: number,
  minimumFractionDigits = 0,
  maximumFractionDigits = 2
) => {
  try {
    return currencyCode
      ? i18next.t('intlCurrency', {
          val: value,
          currencyDisplay:
            config.localization.locize.currencyDisplayFormat ||
            DefaultConfig.LOCALIZATION_CURRENCY_DISPLAY_FORMAT,
          currency: currencyCode,
          minimumFractionDigits,
          maximumFractionDigits
        })
      : `${value}`
  } catch (err) {
    console.log(err)
    return currencyCode ? `${value} ${currencyCode}` : `${value}`
  }
}

export default formatCurrencyValueByLocale
